
class RouteThrowController {
  /*@ngInject*/
  constructor(Auth, $state, User, UsersService, RouteService, $translate, LocationService, ScanService, $location, $q, Modal, ShipmentService, Branch, Sound, $rootScope, DataCounter, DateUtil) {
    this.$translate = $translate;
    this.Auth = Auth;
    this.$state = $state;
    this.User = User;
    this.RouteService = RouteService;
    this.LocationService = LocationService;
    this.ScanService = ScanService;
    this.Sound = Sound;
    this.$q = $q;
    this.Modal = Modal;
    this.ShipmentService = ShipmentService;
    this.$rootScope = $rootScope;
    this.Branch = Branch;
    this.DataCounter = DataCounter;
    this.DateUtil = DateUtil;
    this.UsersService = UsersService;
    this.model = {
      loading: false,
      fromTanker: '',
      toTanker: '',
      bagId: '',
      branchId: ''
    };

    this.lastBagScanned = null;
    this.lastBagScannedErrorCode = null;
    this.hasTanker = false;
    this.routeThrowDate = null;
    // this.audio = this.Sound.errorBeep();
    // this.successAudio = this.Sound.successBeep();
    this.nextVaultDate = null;
    this.vaultDate = null;
    this.errorCodes = ['92813', '91706', '92203', '92204', '92811', '92207', '92205', '92208'];
    this.showForceHoldBtn = false;
    this.routeId = null;
    this.$rootScope.$broadcast('routeChange', '/app/route-throw');
    this.routeDetails = '';
    this.loggedInUser = this.User.getUser().id;
    this.isAlreadyThrown = false;
    this.assignedTankerId = null;
  }

  focusElementById(id) {
    setTimeout(() => {
      document.getElementById(id).focus();
    }, 500)
  }

  convertToDate(date) {
    const ISOString = moment(date).toISOString();
    const DATE_STRING_LENGTH = 10; // length of 'YYYY-MM-DD' format

    const dateString = ISOString.substr(0, DATE_STRING_LENGTH);
    return moment(dateString).toDate();
  }

  $onInit() {
    var self = this;
    this.focusElementById('bagId');
    this.model.branchId = this.User.getUser().branchId;
    this.routeDetails = this.DataCounter.getData();

    this.Branch.getBranchDetails(this.model.branchId)
      .then(function (branchDetails) {
        self.currentVaultDate = self.convertToDate(branchDetails.currentVaultDate);
        self.vaultDate = moment.utc(branchDetails.currentVaultDate).format('YYYY-MM-DD');
        self.minVaultDate = {
          minDate: self.currentVaultDate
        }

        if (self.routeDetails && self.routeDetails.isRedirected) {
          self.nextVaultDate = self.routeDetails.vaultDate;
        }
        else {
          self.nextVaultDate = moment(self.currentVaultDate).add(1, 'days').toDate();
        }
        self.prefixes = branchDetails.prefixes;
        self.isCoinCheckOut = branchDetails.coinCheckOut;
      })
      .then(() => {
        this.resetRedirectionData();
      })
  }

  fromTankerScanned() {
    if (this.model.fromTanker) {
      const searchObj = {
        queryJSON: {
          rules: [
            {
              field: 'locationType',
              condition: '=',
              data: 'TANKER'
            },
            {
              field: 'id',
              condition: '=',
              data: this.model.fromTanker
            }
          ],
          operator: 'AND'
        }
      }

      this.LocationService.all(searchObj, 0, 1)
        .then((res) => {
          if (res.results && res.results.length) {
            this.hasTanker = true;
            this.focusElementById('bagId');
          }
        })
    }
  }

  toTankerScanned() {

    this.routeThrowDate = moment(this.nextVaultDate).format('YYYY-MM-DD');

    if (!this.model.toTanker) {
      return;
    }

    const defer = this.$q.defer();

    delete this.lastStatusUpdate;
    this.isError = false;

    if (this.prefixes && this.prefixes.tanker) {
      if (this.model.toTanker.startsWith(this.prefixes.tanker[0])) {
        var finalToTankerData = this.model.toTanker.slice(this.prefixes.tanker[0].length)
        this.model.toTanker = finalToTankerData;
      }
    }

    this.shipmentRoute = this.model.shipment.routeId;

    this.loading = true;
    this.ShipmentService.throwTanker(this.model.branchId, this.model.bagId, this.model.toTanker, this.routeThrowDate, this.loggedInUser)
      .then(() => {
        this.isError = false;
        this.loading = false;
        this.lastStatusUpdate = new Date();
        this.bagRouteThrowMessage = this.$translate.instant('routeThrow.itemAddedSuccessfully');

        this.isAlreadyThrown = true;
        this.assignedTankerId = this.model.toTanker;

        this.Sound.playSuccessBeep("#success_beep");
        defer.resolve();
      })
      .then(() => {
        if (this.model.shipment) this.throwCount(this.model.shipment.routeId, this.model.branchId, this.routeThrowDate);
      })
      .catch((err) => {
        this.Sound.PlayErrorBeep("#scanner_beep");
        this.focusElementById('toTanker');
        this.loading = false;

        if (err.data.message === '92208') {
          this.getRouteAssignment()
            .then((data) => {
              const date = moment(this.routeThrowDate)
              // console.log("date", date);
              const dow = date.day() + 1;
              // console.log("dow", dow);
              const tanker = data[dow];
              // console.log("tanker", tanker);
              this.bagRouteThrowError = this.$translate.instant('error.' + err.data.message, {
                routeId: this.shipmentRoute,
                tankerId: tanker
              })
            })
        }

        if (err.data.message === '92811') {
          this.RouteService.getRouteTanker(this.shipmentRoute, this.vaultDate)
            .then((routeTanker) => {
              this.bagRouteThrowError = this.$translate.instant('error.' + err.data.message, {
                routeId: this.shipmentRoute,
                tankerId: routeTanker.tankerId
              })
            })
            .catch((e) => {
              this.Modal.errorModal(e.data.message);
            })
        }

        if (err.data.message && this.errorCodes.indexOf(err.data.message) > -1) {
          this.showForceHoldBtn = (err.data.message === "92205") ? true : false
          this.model.bagId = null;
          this.model.shipment = null;
          this.focusElementById('bagId');
        }

        this.model.toTanker = '';
        this.isError = true;
        this.lastStatusUpdate = new Date();
        this.lastBagScannedErrorCode = err.data.message;
        // this.bagRouteThrowError = this.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
        this.bagRouteThrowError = this.$translate.instant('error.' + err.data.message, {
          trackingId: this.lastBagScanned
        }) || 'Error: ' + err.data.message;
        this.scanItem = this.$translate.instant('routeThrow.scan');
        this.scanAgain = this.$translate.instant('routeThrow.again');
        defer.reject();
      })
    return defer.promise.then(() => {
      // return this.setRouteAssignment()
      //   .then(() => {
      this.clearScan(true);
      // })
    })
  }

  bagScanned() {
    this.showForceHoldBtn = false;
    this.routeThrowDate = moment(this.nextVaultDate).format('YYYY-MM-DD');

    if (!this.model.bagId) {
      return;
    }


    if (this.errorCodes.indexOf(this.lastBagScannedErrorCode) > -1) {
      if (this.lastBagScanned && this.lastBagScanned !== this.model.bagId) {
        this.Sound.PlayErrorBeep("#scanner_beep");
        this.isError = true;
        this.model.bagId = null;
        this.model.shipment = null;
        this.lastStatusUpdate = new Date();
        this.bagRouteThrowError = this.$translate.instant('error.rescanLastItemId');
        return;
      }
    }
    delete this.lastStatusUpdate;
    this.lastBagScanned = this.model.bagId;
    this.isError = false;
    this.isAlreadyThrown = false;
    this.assignedTankerId = null;
    this.model.loading = true;
    return this.ScanService.verifyRouteThrowShipment(this.model.branchId, this.model.bagId, this.routeThrowDate)
      .then((response) => {
        this.model.loading = false;
        const { route, shipments } = response;

        if (route.fuzzyMatching) {
          this.Modal.routeThrowShipmentSelectionModal(null, shipments, ({ modal, selected }) => {
            this.model.bagId = selected.trackingId;
            this.bagScanned();
            modal.close();
          }, ({ modal }) => {
            modal.close();
          });
        }
        else if (shipments && shipments[0]) {
          const shipment = shipments[0];

          if (shipment) {
            this.model.shipment = shipment;
            this.shipmentDeliveryDate = moment.utc(shipment.deliveryDate).format('YYYY-MM-DD');
            this.model.route = route;
            this.routeId = shipment.routeId;
            this.Sound.playSuccessBeep("#success_beep");
            this.focusElementById('toTanker');

            this.isAlreadyThrown = !!shipment.tankerId;
            this.assignedTankerId = shipment.tankerId;

            if (!this.isAlreadyThrown) {
              if (route && route.tankerId) {
                this.lastToTankerScanned = route.tankerId;
              } else {
                this.RouteService.getRouteTanker(this.routeId, this.routeThrowDate)
                  .then((routeTanker) => {
                    if (routeTanker && routeTanker.tankerId) {
                      this.lastToTankerScanned = routeTanker.tankerId;
                    }
                  })
                  .catch(() => {});
              }
            }
          }
        }
        else {
          this.model.bagId = null;
          this.Sound.PlayErrorBeep("#scanner_beep");
          this.isError = true;
          this.lastStatusUpdate = new Date();
          this.bagRouteThrowError = this.$translate.instant('error.shipmentNotFound');
        }

        if (this.errorCodes.indexOf(this.lastBagScannedErrorCode) > -1) {
          if (this.lastBagScanned && this.lastBagScanned == this.model.bagId) {
            this.focusElementById('bagId');
            this.model.bagId = null;
            this.model.shipment = null;
            this.Sound.playSuccessBeep("#success_beep");
          }
        }
        this.lastBagScannedErrorCode = '';
      })
      .then(() => {
        if (this.model.shipment) this.throwCount(this.model.shipment.routeId, this.model.branchId, this.routeThrowDate);
      })
      .catch((err) => {
        this.focusElementById('bagId');
        this.Sound.PlayErrorBeep("#scanner_beep");
        this.model.bagId = null;
        this.model.shipment = null;
        this.isError = true;
        this.model.loading = false;
        this.lastStatusUpdate = new Date();
        this.lastBagScannedErrorCode = err.data.message;
        this.bagRouteThrowError = this.$translate.instant('error.' + err.data.message, {
          trackingId: this.lastBagScanned
        }) || 'Error: ' + err.data.message;

        if (err.data.message === '91705' || err.data.message === '92811') {
          this.ShipmentService.getShipmentTrakingDetail(this.lastBagScanned)
            .then((trackingData) => {
              if (trackingData && trackingData.length > 0) {
                const shipment = trackingData.find(s => s.branchId === this.model.branchId && moment(s.deliveryDate).format('YYYY-MM-DD') === this.routeThrowDate);
                if (shipment) {
                  this.model.shipment = shipment;
                  this.model.shipment.toLocationName = shipment.toLocation ? shipment.toLocation.name : '';
                  this.model.shipment.toAddress = shipment.toLocation ?
                    (shipment.toLocation.address + (shipment.toLocation.city ? ', ' + shipment.toLocation.city : '') + (shipment.toLocation.state ? ', ' + shipment.toLocation.state : '') + (shipment.toLocation.zip ? ' ' + shipment.toLocation.zip : ''))
                    : '';
                  this.isAlreadyThrown = !!shipment.tankerId;
                  this.assignedTankerId = shipment.tankerId;
                  this.routeId = shipment.routeId;
                  this.throwCount(this.routeId, this.model.branchId, this.routeThrowDate);
                }
              }
            });
        }
      })
  }

  throwCount(routeId, branchId, date) {
    this.ScanService.shipmentThrowCount(routeId, branchId, date, this.isCoinCheckOut)
      .then((res) => {
        this.model.notThrown = res.notThrown
        this.model.thrownShipments = res.thrownShipments
      }).catch((err) => {
        console.log(err);
      })
  }

  showThrownShipmentsModal() {
    if (!this.model.shipment) return;
    this.ScanService.shipmentThrowList(this.model.shipment.routeId, this.model.branchId, this.routeThrowDate, this.isCoinCheckOut)
      .then((res) => {
        this.Modal.routeThrowShipmentListModal(this.$translate.instant('routeThrow.thrown') + ' Shipments', res.thrown, true);
      }).catch((err) => {
        console.log(err);
      });
  }

  showRemainingShipmentsModal() {
    if (!this.model.shipment) return;
    this.ScanService.shipmentThrowList(this.model.shipment.routeId, this.model.branchId, this.routeThrowDate, this.isCoinCheckOut)
      .then((res) => {
        this.Modal.routeThrowShipmentListModal(this.$translate.instant('routeThrow.remaining') + ' Shipments', res.notThrown, false);
      }).catch((err) => {
        console.log(err);
      });
  }

  keyPressed(controlId, $event) {
    const ESC_KEY_CODE = 27;
    if (controlId === 'bagId') {
      if ($event.keyCode === ESC_KEY_CODE) {
        this.model.bagId = '';
      }
    }
  }

  endScan() {
    this.model = {
      fromTanker: '',
      toTanker: '',
      bagId: ''
    };

    this.hasTanker = false;
    this.focusElementById('fromTanker');
  }

  clearScan(clearOnlyInputs) {
    var obj = {
      bagId: null,
      toTanker: null
    };
    if (!clearOnlyInputs) {
      obj.shipment = null;
      obj.route = null;
      this.shipmentRoute = null;
      this.isAlreadyThrown = false;
      this.assignedTankerId = null;
    }

    this.model = Object.assign(this.model, obj);

    this.focusElementById('bagId');
  }

  itemForceHold() {
    delete this.lastStatusUpdate;

    this.UsersService.checkSupervisor(this.loggedInUser)
      .then((userInfo) => {
        this.Modal.holdReason(this.lastBagScanned, !userInfo.supervisor, ({ supervisorId, reason, modal }) => {
          modal.close()
          this.showForceHoldBtn = false;
          this.ShipmentService.holdShipment(
            this.model.branchId,
            this.lastBagScanned,
            this.routeId,
            moment(this.nextVaultDate).format('YYYY-MM-DD'),
            userInfo.supervisor ? userInfo.id : supervisorId,
            reason
          ).then((response) => {
            this.isError = false;
            this.lastStatusUpdate = new Date();
            this.Sound.playSuccessBeep("#success_beep");
            this.bagRouteThrowMessage = this.$translate.instant('routeThrow.itemaddedtohold');
          }).catch((err) => {
            this.isError = true;
            this.Sound.PlayErrorBeep("#scanner_beep");
            this.lastStatusUpdate = new Date();
            this.bagRouteThrowError = this.$translate.instant('error.' + err.data.message) || 'Error: ' + err.data.message;
          })
        })
      })
      .catch((err) => {
        this.Modal.errorModal(err.data.message);
      })
  }

  clearBagId() {
    this.model.bagId = '';
  }

  clearTankerId() {
    this.model.toTanker = '';
  }

  getRouteAssignment() {
    const defer = this.$q.defer();
    this.RouteService.getTankerAssignments(this.model.shipment.routeId)
      .then((res) => {
        defer.resolve(res);
      })
      .catch((err) => {
        console.log(err);
        defer.reject();
      })
    return defer.promise;
  }

  resetRedirectionData() {
    if (this.routeDetails) {
      this.routeDetails.isRedirected = false;
      this.routeDetails = this.DataCounter.setData();
    }
  }

  // setRouteAssignment() {
  //   const defer = this.$q.defer();
  //   const date = moment(this.routeThrowDate)
  //   const dow = date.day() + 1;
  //   const routeTanker = { [dow]: this.model.toTanker };
  //   console.log("routeTanker", routeTanker);
  //   this.RouteService.setTankerAssignments(this.model.shipment.routeId, routeTanker)
  //     .then((res) => {
  //       defer.resolve(res);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //       defer.reject();
  //     })
  //   return defer.promise;
  // }

}

export default RouteThrowController;/**/



// WEBPACK FOOTER //
// ./client/app/components/route_throw/route_throw.controller.js